import React from "react"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

const MetalProfileProjectPurchasableContainer = ({
    id,
    name,
    theoreticalLength,
    unitPrice,
    unitDiscount,
    purchasable,
    i18n,
    t
}) => {

    return (<>
        <Row>
            {purchasable ?
                <Col md={{ offset: 1, span: 10 }}>
                    <Container className='text-center border p-2 mb-3 bg-white'>
                        <p>{t("Bu, kesim planının özetidir. Detaylı kesim planını elde etmek için bu proje için kesim planı oluşturma hakkını satın almanız gerekmektedir.")}</p>
                        <p><span className='fw-bold text-danger'>{t("NOT")}:</span> {t("Satın alım işlemini sadece bu kesim planı için değil, kesim planının ait olduğu projenin bütün kesim planları için yapmış olacaksınız. Ödemenizin onaylanmasının ardından bu kesim planıyla birlikte")} <a href={`/${i18n.language}/project-info/${id}`}>{name}</a> {t("isimli projenizde oluşturduğunuz ve oluşturacağınız bütün kesim planlarına erişebileceksiniz.")} </p>
                    </Container>
                </Col>
                :
                <Col md={{ offset: 1, span: 10 }}>
                    <Container className='text-center border p-2 mb-3 bg-white'>
                        {t("Bu, kesim planının özetidir. Detaylı kesim planını elde etmek için bu proje için kesim planı oluşturma hakkını satın almanız gerekmektedir. Daha önceden bu proje için oluşturmuş olduğunuz")} <a href={`/${i18n.language}/project-purchase/${id}`}>{t("siparişinizin")}</a> {t("onaylanmasını bekleyiniz.")}
                    </Container>
                </Col>
            }
        </Row>

        {purchasable &&

            <Row className='text-center'>
                <Col md={{ offset: 3, span: 6 }}>
                    <Button style={{ backgroundColor: '#318CE7' }} className='p-3 border' href={`/${i18n.language}/project-purchase/${id}`}>
                        <h5>{t("inactivecpinfo_paymentmsg1")} ({name}) {t("inactivecpinfo_paymentmsg2")}</h5>
                        <div>
                            {unitDiscount !== 0 ?
                                <>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <s style={{ fontSize: "17pt", fontWeight: "400", alignItems: "center" }} >{Math.floor(theoreticalLength * (unitDiscount + unitPrice) * 1e-3)}₺</s>
                                        <s style={{ fontSize: "6pt", marginLeft: "10px" }}> ({(unitDiscount + unitPrice)} ₺/1000m)</s>
                                        <span className='ms-2'>{t("inactive_yerine")}</span>
                                    </div>
                                </>
                                :
                                <></>}
                            <div className='mb-2'>
                                <span style={{ fontSize: "32pt", fontWeight: "600" }}>{Math.floor(theoreticalLength * unitPrice * 1e-3)}₺</span>
                                <div style={{ fontSize: "9pt" }}> (({(theoreticalLength / 1000).toFixed(3)} x1000m) &times; {unitPrice} ₺/1000m)</div>
                            </div>
                        </div>

                        <p>{t("Ödeme yaptıktan sonra bu proje için istediğiniz kadar kesim planı oluşturabilir ve detaylarını elde edebilirsiniz.")}</p>
                    </Button>
                </Col>

                {/* <Col md={{ span: 5 }}>
                        <Button style={{ backgroundColor: '#0073ba', height:"230px" }} className='p-3 border'>
                            <h5>Kredi satın al</h5>
                            <h3>Fiyat bilgisi için tıklayınız</h3>
                            <p>Birim ağırlık başına daha az ücret ödeyerek toplu optimizasyon hakkı (kredi) satın alabilir, kredilerinizi gelecek projelerinizde de kullanabilirsiniz. Detaylı bilgi için tıklayınız.</p>
                        </Button>
                    </Col> */}
            </Row>
        }
    </>)
}

export default MetalProfileProjectPurchasableContainer;